<!--  -->
<template>
  <div>

    <!-- Banner Start -->
    <section class="page-banner" style="background-image: url(/static/images/banner4.jpg);">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h2 class="banner-title">课程列表</h2>
                    <div class="bread-crumbs">
                        <router-link to="/">首页</router-link> <span></span> 我的课程
                    </div>
                </div>
            </div>
        </div>
    </section>  
    <!-- Banner End -->

    <!-- Course Section Start -->
    <section class="coursepage-section-2">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="toolbar-wrapper-2">
                        <ul class="toolbar-btn nav nav-tabs">
                            <li><a class="active" href="#grid" data-toggle="tab"><i class="icon_grid-2x2"></i>网格显示</a></li>
                            <li><a href="#list" data-toggle="tab"><i class="icon_menu"></i>列表显示</a></li>
                        </ul>
                        <div class="sorting">
                            <p>科目:</p>
                            <select name="orderby" class="orderby" v-model="searchType">
                                <option value="">所有科目</option>
                                <option v-for="(courcate,index) in $root.hasCourse" :key="index" :value="courcate">{{courcate}}</option>
                            </select>
                        </div>
                        <div class="search-box">
                            <input type="search" v-model="searchWords" placeholder="搜索课程...">
                            <button type="submit"  @click="toPage(1)"><i class="ti-search"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-9">
                    <!-- Tab Content -->
                    <div class="tab-content">
                        <!-- Grid Tab -->
                        <div class="tab-pane fade show in active" id="grid" role="tabpanel">
                            <div class="row">
                                <div class="col-lg-4 col-md-6" v-for="(course,index) in courses" :key="index">
                                    <div class="feature-course-item-4">
                                        <div class="fcf-thumb">
                                            <img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt="">
                                            <router-link class="enroll" :to="`/courview/info/${course._id}`">{{course.isBuy==1? '立即学习':course.isBuy==0?'报名学习':course.isBuy==3?'未开始':'已到期'}}</router-link>
                                        </div>
                                        <div class="fci-details">
                                            <a href="#" class="c-cate"><i class="icon_tag_alt"></i>{{course.type}}</a>
                                            <h4><router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link></h4>
                                            <div class="author">
                                                <img src="/static/images/home3/course/a1.png" alt="">
                                                <a>{{course.author}}</a>
                                            </div>
                                            <div class="price-rate">
                                                <div class="course-price">
                                                    {{course.students?course.students:0}}人报名
                                                </div>
                                                <div class="ratings">
                                                    <i class="icon_star"></i>
                                                    <span v-if="course.stars">{{parseFloat(course.stars).toFixed(1) }}</span>
                                                    <span v-else>暂无评分</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Pagination -->
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="bisylms-pagination">
                                        <el-pagination
                                        background
                                        :page-size="6"
                                        :hide-on-single-page="intTotal<=6"
                                        layout="prev, pager, next"
                                        @current-change="toPage"
                                        @prev-click="toPage"
                                        @next-click="toPage"
                                        :total="intTotal">
                                    </el-pagination>
                                    </div>
                                </div>
                            </div>
                            <!-- Pagination -->
                        </div>
                        <!-- Grid Tab -->

                        <!-- List Tab -->
                        <div class="tab-pane fade in" id="list" role="tabpanel">

                            <div class="course-item-4"  v-for="(course,index) in courses" :key="index">
                                <div class="ci-thumb">
                                    <img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt="">
                                    <router-link class="enroll" :to="`/courview/info/${course._id}`">{{course.isBuy==1? '立即学习':course.isBuy==0?'报名学习':course.isBuy==3?'未开始':'已到期'}}</router-link>
                                </div>
                                <div class="course-details">
                                    <a  class="c-cate"><i class="icon_tag_alt"></i>{{course.type}}</a>
                                    <h4><router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link></h4>
                                    <!-- <h4>&nbsp;</h4> -->
                                    <div class="author">
                                        <img src="/static/images/home3/course/a1.png" alt="">
                                        <a>{{course.author}}</a>
                                    </div>
                                    <div class="price-rate">
                                        <div class="course-price">
                                            {{course.students?course.students:0}}人报名
                                        </div>
                                        <div class="ratings">
                                        <i class="icon_star"></i>
                                            <span v-if="course.stars">{{parseFloat(course.stars).toFixed(1) }}</span>
                                            <span v-else>暂无评分</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Pagination -->
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="bisylms-pagination">
                                        <el-pagination
                                        background
                                        :page-size="6"
                                        :hide-on-single-page="intTotal<=6"
                                        layout="prev, pager, next"
                                        @current-change="toPage"
                                        @prev-click="toPage"
                                        @next-click="toPage"
                                        :total="intTotal">
                                    </el-pagination>
                                    </div>
                                </div>
                            </div>
                            <!-- Pagination -->
                        </div>
                        <!-- Grid Tab -->
                    </div>
                    <!-- Tab Content -->
                </div>
                <div class="col-lg-3">
                    <div class="course-sidebar">
                    <aside class="widget">
                            <h3 class="widget-title">排序</h3>
                            <ul>
                                <li><a @click="sortType='-createdAt'">发布时间</a></li>
                                <li><a @click="sortType='stars'">评分</a></li>
                                <li><a @click="sortType='price'">价格</a></li>
                                <li><a @click="sortType='students'">购买人数</a></li>
                            </ul>
                        </aside>
                        <aside class="widget widget-filter">
                            <h3 class="widget-title">级别分类</h3>
                            <div class="clearfix">
                                <div class="price-filter">
                                    <ul>
                                        <li>
                                            <input type="checkbox" checked="checked" id="all" name="all" value="高级" v-model="searchLevel">
                                            <label for="all">
                                                高级
                                            </label>
                                        </li>
                                        <li>
                                            <input type="checkbox" id="premium" name="premium" value="中级" v-model="searchLevel">
                                            <label for="premium">
                                                中级
                                            </label>
                                        </li>
                                        <li>
                                            <input type="checkbox" id="free" name="free" value="初级" v-model="searchLevel">
                                            <label for="free">
                                                初级
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </aside>
                        <aside class="widget  widget-filter">
                            <h3 class="widget-title">评分</h3>
                            <ul class="rating__list">
                                <li>
                                    <label class="review-label">
                                        <input type="radio" checked="checked" value="5" v-model="searchStars">
                                        <el-rate
                                        style="display: contents;"
                                        value ="5"
                                        disabled
                                        text-color="#ff9900">
                                        </el-rate>
                                    </label>
                                </li>
                                <li>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="4" v-model="searchStars">
                                        <el-rate
                                        style="display: contents;"
                                        value ="4"
                                        disabled
                                        text-color="#ff9900">
                                        </el-rate>
                                    </label>
                                </li>
                                <li>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="3" v-model="searchStars">
                                        <el-rate
                                        style="display: contents;"
                                        value ="3"
                                        disabled
                                        text-color="#ff9900">
                                        </el-rate>
                                    </label>
                                </li>
                                <li>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="2" v-model="searchStars">
                                        <el-rate
                                        style="display: contents;"
                                        value ="2"
                                        disabled
                                        text-color="#ff9900">
                                        </el-rate>
                                    </label>
                                </li>
                                <li>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="1" v-model="searchStars">
                                        <el-rate
                                        style="display: contents;"
                                        value ="1"
                                        disabled
                                        text-color="#ff9900">
                                        </el-rate>
                                    </label>
                                </li>
                            </ul>
                        </aside>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Course Section End -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      courses: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") { 
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
    this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt&type[in]="+ this.$root.hasCourse)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
          this.intTotal = res.data.total;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    toTop() {
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
        if(this.$root.hasCourse.length==0) {
            return
        }
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }else{
        searchConditions +=`&type[in]=${this.$root.hasCourse}`;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=-createdAt";
      }

      this.$axios
        .get(
          `/api/courses/visitor?page=${
            this.intCurrent
          }&limit=6${searchConditions}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.courses = res.data.data;
            this.toTop();
          }
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
::v-deep .el-pager li.active {
  color: #51be78;
}
a:not([href]):not([tabindex]){
  color:initial !important;
}
</style>
